// Command-palette actions for the office global search (Session AAV, Loop 2). Pure data +
// filter so the palette is instant and testable. These are ACTIONS (things to do), shown
// above the page and record results; the record search already answers "find quote by ref"
// and "jump to site" for a typed term, so the two search actions here are entry points that
// open the right list.
export interface CommandAction {
  label: string;
  subtitle: string;
  url: string;
  keywords: string; // extra match terms beyond the label
}

export const COMMAND_ACTIONS: CommandAction[] = [
  {
    label: "New quote",
    subtitle: "Open the quote calculator",
    url: "/office/quotes/new",
    keywords: "create price calculator maintenance",
  },
  {
    label: "New quote from template",
    subtitle: "Start the calculator from a saved configuration",
    url: "/office/quotes/new?templates=1",
    keywords: "template reuse saved configuration",
  },
  {
    label: "Open quote analytics",
    subtitle: "The funnel, win and loss, and ARR pipeline",
    url: "/office/quote-analytics",
    keywords: "analytics funnel conversion arr pipeline win loss",
  },
  {
    label: "Find a quote",
    subtitle: "Open the quotes list (or type a reference here to search)",
    url: "/office/quotes",
    keywords: "quote reference ref search list",
  },
  {
    label: "Jump to a site",
    subtitle: "Open the sites register (or type a site name here to search)",
    url: "/office/sites",
    keywords: "site building jump go register",
  },
];

// Filter the actions by a typed query (case-insensitive, over label + keywords). An empty
// query returns them all -- the palette shows every action when opened with Cmd/Ctrl+K
// before anything is typed, like the Linear palette.
export function searchActions(query: string): CommandAction[] {
  const q = query.trim().toLowerCase();
  if (!q) return COMMAND_ACTIONS;
  return COMMAND_ACTIONS.filter((a) => `${a.label} ${a.keywords}`.toLowerCase().includes(q));
}
